export default "__VITE_ASSET__Bbhl6WeR__"